document.querySelectorAll('.image-grid-section').forEach(imageGridSection => {

  function imageGridScroller() {
    const imageGridElement = imageGridSection.querySelector('.image-grid');
    const imageGridScrollerElement = imageGridSection.querySelector('.image-grid--scrolling');
    const imageGridItems = imageGridSection.querySelectorAll('.image-grid--image-item');
    const imageGridItemsLength = imageGridItems.length;
    const imageGridScrollButtons = imageGridSection.querySelector('.image-grid--scroller-buttons');
    const imageGridScrollRight = imageGridSection.querySelector(".scroll-button-right");
    const imageGridScrollLeft = imageGridSection.querySelector(".scroll-button-left");

    let scrollAmount = 0;

    const updateButtonStates = () => {
      const maxScrollLeft = imageGridScrollerElement.scrollWidth - imageGridScrollerElement.clientWidth;

      if (!imageGridScrollerElement.scrollLeft <= 0) {
        imageGridScrollLeft.classList.remove('button-disabled')
      } else {
        imageGridScrollLeft.classList.add('button-disabled')
      }

      if (imageGridScrollerElement.scrollLeft >= maxScrollLeft) {
        imageGridScrollRight.classList.add('button-disabled')
      } else {
        imageGridScrollRight.classList.remove('button-disabled')
      }

    };

    imageGridScrollRight.addEventListener('click', event => {
      scrollAmount += 400;
      imageGridScrollerElement.scrollLeft = scrollAmount;
    })

    imageGridScrollLeft.addEventListener('click', event => {
      scrollAmount -= 400;
      imageGridScrollerElement.scrollLeft = scrollAmount;
    })

    imageGridScrollerElement.addEventListener('scroll', () => {
      updateButtonStates();
    });

    updateButtonStates();
  }

  document.addEventListener('DOMContentLoaded', imageGridScroller);

});